<template>
  <v-container fluid>
    <h1 class="display-2 my-6 mx-auto primary--text text--darken-2 text-center">
      Hallo und herzlich willkommen zum<br>
      Kegelmanager Online!
    </h1>
    <v-img
      src="/static/img/Logo.png"
      alt="Κegelmanager"
      max-height="175px"
      max-width="175px"
      class="mx-auto my-8"
    />
    <v-row
      v-if="$store.state.matchEvaluationInProgress"
      class="mb-12"
      justify="center"
    >
      <v-col
        align-self="center"
        justify="center"
        cols="11"
        md="9"
        class="text-center orange darken-4 elevation-6 mx-auto"
      >
        <v-card>
          <v-card-title primary-title>
            <h3 class="display-1 font-weight-medium mx-auto">
              Auswertungen oder Wartungsarbeiten laufen gerade...
            </h3>
          </v-card-title>
          <v-divider />
          <v-card-text class="subtitle-1">
            Momentan wird gerade der Spieltag ausgewertet oder am Server gearbeitet.<br>
            Bis dahin sind die Log-In und Registrierfunktionen ausgeschaltet.
            <br>Bitte schaue in ein paar Minuten/Stunden wieder vorbei.<br>
            Eine Telegramm-Nachricht geht raus, wenn die Arbeiten vorbei sind.
          </v-card-text>
          <v-divider class="mb-1" />
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="mb-12 text-center"
      justify="center"
    >
      <v-col
        align-self="center"
        cols="11"
        md="9"
        class="white elevation-6 mx-auto"
      >
        <v-card dark color="primary" class="blue-gradient">
          <v-card-title primary-title>
            <h3 class="display-1 font-weight-medium mx-auto">
              Kegelmanager
            </h3>
          </v-card-title>
          <v-divider />
          <v-card-text class="subtitle-1 white--text">
            Nun ist es endlich soweit. Nach langer Pause ist der neue Kegelmanager (Beta-Phase) online. Egal ob Du neu oder ein alter Hase bist, 200 oder 120 Wurf beführwortest, der Kegelmanager ist für alle diejenigen, die Spaß am Kegeln haben. Also mach mit :-)<br>
            (Die Auswertung eines Spieltages ist Mittwoch und Freitag Abend ab 22:00 Uhr.)
          </v-card-text>
          <v-divider class="mb-1" />
          <v-card-actions>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="6"
                md="3"
              >
                <v-btn
                  v-show="!$store.state.matchEvaluationInProgress"
                  outlined large
                  dark
                  to="/login"
                >
                  Login
                  <v-icon dark class="ml-1">
                    mdi-login
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                md="3"
              >
                <v-btn
                  v-show="!$store.state.matchEvaluationInProgress"
                  outlined large
                  dark
                  to="/register"
                >
                  Registrieren
                  <v-icon dark class="ml-1">
                    mdi-account-plus
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-show="$store.state.matchEvaluationInProgress"
              >
                <v-btn
                  dark
                >
                  Auswertung läuft...
                </v-btn>
                <br>
              </v-col>

              <v-divider vertical class="ma-2 hidden-sm-and-down" />

              <v-col>
                <v-btn
                  outlined
                  small
                  dark
                  href="https://www.facebook.com/groups/kegelmanager"
                  target="_blank"
                >
                  Facebook
                  <v-icon dark class="ml-1">
                    mdi-facebook-box
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  outlined
                  small
                  dark
                  href="https://t.me/kegelmanager"
                  target="_blank"
                >
                  Telegram
                  <v-icon dark class="ml-1">
                    mdi-telegram
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-12" />
    </v-row>
    <v-row
      align="center"
      justify="space-around"
      class="white py-6"
    >
      <v-col
        cols="12"
        md="5"
      >
        <v-card dark color="amber darken-4" class="orange-gradient">
          <v-card-title primary-title>
            <h3 class="display-1 font-weight-medium">
              Kegelmanager 2007 - 2009
            </h3>
          </v-card-title>
          <v-divider />
          <v-card-text class="body-1 white--text">
            Vielleicht kennst Du noch den Kegelmanager von 2007.<br> Bei dem konntest Du ein Team zusammenstellen und es von der vierten bis in die erste Liga führen, Pokalsieger werden und Deine Spieler bei Einzelmeisterschaften zu Meriten führen. Doch bist Du gefangen in immer den vier selben Ligen und spielst immer gegen die selben Gegner.
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="5"
      >
        <v-card dark color="amber darken-4" class="orange-gradient">
          <v-card-title primary-title>
            <h3 class="display-1 font-weight-medium">
              Kegelmanager 2009 - 2011
            </h3>
          </v-card-title>
          <v-divider />
          <v-card-text class="body-1  white--text">
            <p>Vielleicht kennst Du noch den Kegelmanager von 2009.<br>Beim dem hattest Du nun die Möglichkeit, Dich mit anderen Spielern direkt zu messen. Aber auch hier gilt: kämpfe Dich von der untersten Liga bis nach oben! Wie viele Ligen Du dich hochkämpfen musst, hängt von der Anzahl der Teilnehmer ab.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-12">
      <v-divider />
    </v-row>

    <v-row
      align="center"
      justify="space-around"
      class="primary darken-2 white--text blue-gradient mt-12"
    >
      <v-col
        align="center"
        cols="11"
        md="8"
        class="mb-6 py-6 text-left"
      >
        <h2 class="display-2 font-weight-light">
          Warum nun wieder ein Kegelmanager?
        </h2>
        <v-divider dark class="my-6" />

        <div class="headline mx-auto fw300">
          <p>
            Wenn Du den KMO noch von 2007-2010/11 kennst und dich jetzt fragst:<br>
            Spotty bist Du das?, dann muss ich Dir sagen, nein hier ist nicht Spotty...<br>
            <small>(Danke an Spotty für die geile Idee und das Konzept!)</small>
          </p>
          <p>
            Da ich damals beide Versionen als Spieler miterlebt habe, fand ich es sehr schade, als 2010/2011 Schluss mit dem Kegelmanager war.
          </p>
          <p>
            Damals wollte ich sofort das Spiel nachprogrammieren. Paar Designideen hatte ich noch ins alte Forum veröffentlicht. Aber irgendwie fehlte mir dann immer die Zeit und Lust... (unten sind noch paar Bilder von den damaligen Ideen)
          </p>
          <p>
            Der Gedanke das Spiel nachzuprogrammieren ließ mir die Jahre keine Ruhe. Als die Domain 2017 zum kauf frei war, schnappte ich mir diese und begann die Gedanken in Bits und Bytes umzuwandeln. Je nach Zeit, Lust und Laune werkelte ich daran.
          </p>
          <p>Anfang 2019 ging das Spiel in die öffentliche Beta-Phase, um die ersten Rückmeldungen zum Design und Spiel zu erhalten.</p><p>Ende November 2019, wurde das Auf- und Absteigssystem implementiert, somit konnte dann eine neue Saison gestartet werden und das Spielt nährt sich der Version 1.0.0.</p>
          <p>So nach und nach, wenn ich Zeit finde, kommen neue Funktionen hinzu und das Spiel wächst von Version zu Version.</p>
          <p>In Deinem Managerbüro kannst Du dir dein Team für den Spieltag zusammenstellen, Dir einen Überblick über die Finanzen verschaffen, Spieler einkaufen oder verkaufen, und ...</p>
          <p>
            Jeden Mittwoch und Freitag ab ca. 22:00 Uhr läuft die Auswertung des aktuellen Spieltags. Danach kannst Du sehen, wie Dein Team gespielt hat.<br>
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row
      class="my-12"
    >
      <v-col
        cols="8"
        md="4"
        sm="5"
        class="mx-auto"
      >
        <p class="headline font-weight-bold font-italic mb-6">
          Design von 2011 - erste Ideen...
        </p>
        <v-carousel
          light
          show-arrows
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          interval="3000"
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(item,i) in protos"
            :key="i"
            :src="item.src"
          />
        </v-carousel>
      </v-col>

      <v-col
        cols="8"
        md="4"
        sm="5"
        class="mx-auto"
      >
        <p class="headline font-weight-bold font-italic mb-6">
          Das alte KMO-Spiel von 2009-2011
        </p>
        <v-carousel
          light
          show-arrows
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
          interval="3000"
          show-arrows-on-hover
        >
          <v-carousel-item
            v-for="(item,i) in items"
            :key="i"
            :src="item.src"
          />
        </v-carousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Startseite'
  },
  data () {
    return {
      items: [
        {
          src: '/static/img/oldgame/kegelmanager-start.jpg'
        },
        {
          src: '/static/img/oldgame/mannschaft.jpg'
        },
        {
          src: '/static/img/oldgame/tabelle.jpg'
        },
        {
          src: '/static/img/oldgame/kegelhalle.jpg'
        },
        {
          src: '/static/img/oldgame/fahrzeug.jpg'
        },
        {
          src: '/static/img/oldgame/finanzen.jpg'
        },
        {
          src: '/static/img/oldgame/spielerboerse.jpg'
        }
      ],
      protos: [
        {
          src: '/static/img/oldgame/proto-1.jpg'
        },
        {
          src: '/static/img/oldgame/proto-2.jpg'
        },
        {
          src: '/static/img/oldgame/proto-3.jpg'
        },
        {
          src: '/static/img/oldgame/proto-4.jpg'
        },
        {
          src: '/static/img/oldgame/proto-5.jpg'
        },
        {
          src: '/static/img/oldgame/proto-6.jpg'
        },
        {
          src: '/static/img/oldgame/proto-7.jpg'
        }
      ]
      // matchEvaluationInProgress: false,
      // interval: null
    }
  },
  mounted: function () {

  },
  methods: {

  },
  beforeDestroy: function () {

  }
}
</script>
<style scoped>
.break-word{
  word-break: break-all;
}

.item {
  min-height: 50px;
  min-width: 80px;
  margin: 10px;
}
.fw300{
  font-weight: 300;
}

.blue-gradient {
  background: #0d47a1 !important;
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+CiAgICA8c3RvcCBvZmZzZXQ9IjAlIiBzdG9wLWNvbG9yPSIjMGQ0N2ExIiBzdG9wLW9wYWNpdHk9IjEiLz4KICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzIxOTZmMyIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=)!important;
  background: -moz-linear-gradient(-45deg,  #0d47a1 0%, #2196f3 100%) !important;
  background: -webkit-linear-gradient(-45deg,  #0d47a1 0%,#2196f3 100%) !important;
  background: linear-gradient(135deg,  #0d47a1 0%,#2196f3 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0d47a1', endColorstr='#2196f3',GradientType=1 ) !important;
}
.orange-gradient {
  background-color: #FF6F00 !important;
  background-image: -webkit-linear-gradient(170deg, #FF6F00, #ff923f 100%) !important;
  background-image: -moz-linear-gradient(170deg, #FF6F00 0%, #ff923f 100%) !important;
  background-image: -o-linear-gradient(170deg, #FF6F00 0%, #ff923f 100%) !important;
  background-image: linear-gradient(170deg, #FF6F00 0%, #ff923f 100%) !important;
}
</style>
